var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState, useRef } from 'react';
import useWidgetStore from '../../../../stores/widgetStore';
import useConfigStore from '../../../../stores/configStore';
import PolicyStepsHeader from '../../../common/PolicyStepsHeader';
import { brizaCollect } from '@briza/collect';
import MoneyMinusIcon from '../../../icons/MoneyMinusIcon';
import MoneyTagIcon from '../../../icons/MoneyTagIcon';
import MoneyWalletIcon from '../../../icons/MoneyWalletIcon';
import shade from '../../../../utils/shade';
var formatErrorMessage = function (errorMessage, fieldPath) {
    var fieldNames = {
        'payment.number': 'Card number',
        'payment.cvc': 'Security code',
        'payment.name': 'Name on card',
        'payment.email': 'Email',
        'payment.address.street': 'Address',
        'payment.address.city': 'City',
        'payment.address.region': 'State/Region',
        'payment.address.postalCode': 'ZIP code',
        'payment.address.country': 'Country',
        'payment': 'Expiration date'
    };
    var fieldName = fieldNames[fieldPath] || 'This field';
    var errorMappings = {
        'is required': "".concat(fieldName, " is required"),
        'is not a valid card number': 'Please enter a valid card number',
        'is not a valid security code': 'Please enter a valid security code',
        'is not a valid expiration date': 'Please enter a valid expiration date',
        "the value doesn't match a pattern": 'Please enter a valid email address'
    };
    for (var _i = 0, _a = Object.entries(errorMappings); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (errorMessage.toLowerCase().includes(key.toLowerCase())) {
            return value;
        }
    }
    return "".concat(fieldName, ": ").concat(errorMessage);
};
var ErrorMessage = function (_a) {
    var error = _a.error, fieldPath = _a.fieldPath;
    var isExpirationField = fieldPath === 'payment';
    var expirationKeys = [
        'payment.expiration',
        'payment.expirationDate',
        'payment',
    ];
    var errorData = error[fieldPath];
    if (isExpirationField && !errorData) {
        for (var _i = 0, expirationKeys_1 = expirationKeys; _i < expirationKeys_1.length; _i++) {
            var key = expirationKeys_1[_i];
            if (error[key]) {
                errorData = error[key];
                break;
            }
        }
    }
    if (!errorData)
        return null;
    var errorMessages = [];
    if (Array.isArray(errorData)) {
        errorMessages = errorData;
    }
    else if (typeof errorData === 'string') {
        errorMessages = [errorData];
    }
    else if (errorData &&
        typeof errorData === 'object' &&
        Array.isArray(errorData.errorMessages)) {
        errorMessages = errorData.errorMessages;
    }
    else if (errorData &&
        typeof errorData === 'object' &&
        typeof errorData.errorMessages === 'string') {
        errorMessages = [errorData.errorMessages];
    }
    if (!errorMessages.length) {
        return null;
    }
    var message = errorMessages[0];
    if (errorMessages.length > 1) {
        var validationError = errorMessages.find(function (msg) { return !msg.toLowerCase().includes('is required'); });
        if (validationError) {
            message = validationError;
        }
    }
    var formattedMessage = formatErrorMessage(message, fieldPath);
    return React.createElement("span", { className: "text-red-500 text-sm mt-1" }, formattedMessage);
};
var BrizaPaymentForm = function (_a) {
    var _b, _c;
    var quoteId = _a.quoteId, selectedPlan = _a.selectedPlan, setSelectedPlan = _a.setSelectedPlan, purchaseQuoteMutation = _a.purchaseQuoteMutation, onSuccess = _a.onSuccess, isPurchaseLoading = _a.isPurchaseLoading, stepInfo = _a.stepInfo;
    var _d = useWidgetStore(), modalOpen = _d.modalOpen, policyPaymentPayloads = _d.policyPaymentPayloads, unifiedState = _d.unifiedState, setPolicyPaymentPayloads = _d.setPolicyPaymentPayloads, setSelectedPolicyPayload = _d.setSelectedPolicyPayload;
    var style = useConfigStore().style;
    var primaryColor = style.primaryColor, theme = style.theme;
    var pColor = primaryColor || '#3B82F6';
    var _e = useState({}), error = _e[0], setErrors = _e[1];
    var _f = useState(false), showSuccessMessage = _f[0], setShowSuccessMessage = _f[1];
    var _g = useState(false), isSubmitting = _g[0], setIsSubmitting = _g[1];
    var gatewayRef = useRef(null);
    var isMultipleFlow = ((stepInfo === null || stepInfo === void 0 ? void 0 : stepInfo.total) || 0) > 1;
    var isLastPolicy = (stepInfo === null || stepInfo === void 0 ? void 0 : stepInfo.current) === (stepInfo === null || stepInfo === void 0 ? void 0 : stepInfo.total);
    // --- Credit Card Fee Calculations ---
    var paymentMethods = unifiedState === null || unifiedState === void 0 ? void 0 : unifiedState.paymentMethods;
    var ccFeePercentStr = (_b = paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods[0]) === null || _b === void 0 ? void 0 : _b.feePercent;
    var feePercentNum = ccFeePercentStr ? parseFloat(ccFeePercentStr) : 0;
    var hasCcFee = !isNaN(feePercentNum) && feePercentNum > 0;
    var rawComplianceText = (_c = paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods[0]) === null || _c === void 0 ? void 0 : _c.complianceText;
    var baseDownpayment = Number((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.downpayment) || 0);
    var downpaymentFee = hasCcFee ? (baseDownpayment * feePercentNum) / 100 : 0;
    var totalDownpayment = baseDownpayment + downpaymentFee;
    var baseInstallment = Number((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.installmentPayment) || 0);
    var installmentFee = hasCcFee ? (baseInstallment * feePercentNum) / 100 : 0;
    var totalInstallment = baseInstallment + installmentFee;
    var installmentCount = Number((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.installmentNumberOfTimes) || 0);
    var totalPayableAmount = totalDownpayment + totalInstallment * installmentCount;
    var extractEmailErrorMessage = function (err) {
        var _a, _b, _c, _d;
        if (!err || typeof err !== 'object') {
            return null;
        }
        var nestedValue = ((_a = err.meta) === null || _a === void 0 ? void 0 : _a['body.payment.email']) ||
            ((_d = (_c = (_b = err.meta) === null || _b === void 0 ? void 0 : _b.body) === null || _c === void 0 ? void 0 : _c.payment) === null || _d === void 0 ? void 0 : _d.email) ||
            err['payment.email'];
        if (typeof nestedValue === 'string') {
            return nestedValue;
        }
        if (Array.isArray(nestedValue) && typeof nestedValue[0] === 'string') {
            return nestedValue[0];
        }
        if (nestedValue &&
            typeof nestedValue === 'object' &&
            typeof nestedValue.errorMessages === 'string') {
            return nestedValue.errorMessages;
        }
        if (nestedValue &&
            typeof nestedValue === 'object' &&
            Array.isArray(nestedValue.errorMessages) &&
            typeof nestedValue.errorMessages[0] === 'string') {
            return nestedValue.errorMessages[0];
        }
        return null;
    };
    var setNormalizedErrors = function (err) {
        var normalizedError = err && typeof err === 'object' && !Array.isArray(err) ? __assign({}, err) : {};
        if ((err === null || err === void 0 ? void 0 : err.meta) && typeof err.meta === 'object') {
            var expirationMetaKeys = [
                'body.payment.expYear',
                'body.payment.expMonth',
            ];
            for (var _i = 0, expirationMetaKeys_1 = expirationMetaKeys; _i < expirationMetaKeys_1.length; _i++) {
                var key = expirationMetaKeys_1[_i];
                var metaValue = err.meta[key];
                if (metaValue && !normalizedError['payment']) {
                    normalizedError['payment'] = {
                        errorMessages: ['Please enter a valid expiration date']
                    };
                    break;
                }
            }
        }
        var emailMessage = extractEmailErrorMessage(err);
        if (emailMessage) {
            normalizedError['payment.email'] = {
                errorMessages: [emailMessage]
            };
        }
        setErrors(normalizedError);
    };
    var handleContinue = function () {
        if (onSuccess) {
            onSuccess();
        }
    };
    var token = 'sk-fb3f2a2229fa20f2d18b0364ebe905d901e3f492589e47bc9328f3d02e437b38fc40fd6f6e9357d6';
    var environment = 'sandbox';
    useEffect(function () {
        function initializeBriza() {
            return __awaiter(this, void 0, void 0, function () {
                var existingIframes, gateway, form, handleSubmit, err_1;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            existingIframes = document.querySelectorAll('iframe[src*="briza"]');
                            existingIframes.forEach(function (iframe) { return iframe.remove(); });
                            setErrors({});
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            return [4 /*yield*/, brizaCollect({
                                    token: token,
                                    environment: environment,
                                    fields: {
                                        'address': '#address',
                                        'country': '#country',
                                        'city': '#city',
                                        'region': '#region',
                                        'zip-code': '#zip-code',
                                        'email': '#email',
                                        'card-name': '#card-name',
                                        'card-number': '#card-number',
                                        'card-expiration-date': '#card-expiration-date',
                                        'card-security-code': '#card-security-code'
                                    },
                                    css: {
                                        'background': '#F8FAFE',
                                        'border': '2px solid #E9EDF7',
                                        'width': '100%',
                                        'padding': '10px 12px',
                                        'fontSize': '16px',
                                        'lineHeight': '1.25',
                                        'color': '#252846',
                                        'boxSizing': 'border-box',
                                        'borderRadius': '12px',
                                        '::placeholder': {
                                            color: '#6B7280'
                                        },
                                        ':focus': {
                                            border: "2px solid ".concat(pColor)
                                        }
                                    }
                                })];
                        case 2:
                            gateway = _a.sent();
                            return [4 /*yield*/, gateway.onReady()];
                        case 3:
                            _a.sent();
                            gatewayRef.current = gateway;
                            form = document.getElementById('cc-form');
                            if (form) {
                                handleSubmit = function (e) { return __awaiter(_this, void 0, void 0, function () {
                                    var response, paymentPayload, updatedPayloads, err_2;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                e === null || e === void 0 ? void 0 : e.preventDefault();
                                                setIsSubmitting(true);
                                                _a.label = 1;
                                            case 1:
                                                _a.trys.push([1, 9, 10, 11]);
                                                return [4 /*yield*/, gatewayRef.current.tokenize()];
                                            case 2:
                                                response = _a.sent();
                                                paymentPayload = __assign(__assign({}, response), { externalQuoteId: quoteId, installmentFrequency: selectedPlan['installmentFrequency'], quoteKey: selectedPlan.quoteKey, collectPayment: true });
                                                if (!isMultipleFlow) return [3 /*break*/, 6];
                                                updatedPayloads = __spreadArray(__spreadArray([], (policyPaymentPayloads || []), true), [
                                                    paymentPayload,
                                                ], false);
                                                if (!isLastPolicy) return [3 /*break*/, 4];
                                                return [4 /*yield*/, purchaseQuoteMutation(updatedPayloads)];
                                            case 3:
                                                _a.sent();
                                                setPolicyPaymentPayloads([]);
                                                setSelectedPolicyPayload(null);
                                                if (onSuccess) {
                                                    onSuccess();
                                                }
                                                return [3 /*break*/, 5];
                                            case 4:
                                                setPolicyPaymentPayloads(updatedPayloads);
                                                setShowSuccessMessage(true);
                                                _a.label = 5;
                                            case 5: return [3 /*break*/, 8];
                                            case 6: return [4 /*yield*/, purchaseQuoteMutation(paymentPayload)];
                                            case 7:
                                                _a.sent();
                                                setPolicyPaymentPayloads([]);
                                                setSelectedPolicyPayload(null);
                                                if (onSuccess) {
                                                    onSuccess();
                                                }
                                                _a.label = 8;
                                            case 8: return [3 /*break*/, 11];
                                            case 9:
                                                err_2 = _a.sent();
                                                console.log('error in briza payment form', err_2);
                                                setNormalizedErrors(err_2);
                                                return [3 /*break*/, 11];
                                            case 10:
                                                setIsSubmitting(false);
                                                return [7 /*endfinally*/];
                                            case 11: return [2 /*return*/];
                                        }
                                    });
                                }); };
                                form.addEventListener('submit', handleSubmit);
                            }
                            return [3 /*break*/, 5];
                        case 4:
                            err_1 = _a.sent();
                            console.log('error initializing briza', err_1);
                            setNormalizedErrors(err_1);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
        initializeBriza();
        return function () {
            var iframes = document.querySelectorAll('iframe[src*="briza"]');
            iframes.forEach(function (iframe) { return iframe.remove(); });
            gatewayRef.current = null;
        };
    }, [quoteId]);
    // Success message component
    if (showSuccessMessage && isMultipleFlow) {
        return (React.createElement("div", { className: modalOpen
                ? 'w-full h-[92vh] absolute top-1 left-0 flex flex-col items-center justify-center overflow-hidden sm:w-full sm:h-[95%]'
                : 'w-[80%] flex flex-col items-center justify-center min-h-[500px]' },
            React.createElement("div", { className: "w-full max-w-md px-6 py-8 flex flex-col items-center gap-6" },
                React.createElement("div", { className: "w-20 h-20 rounded-full flex items-center justify-center", style: { backgroundColor: primaryColor } },
                    React.createElement("svg", { className: "w-12 h-12 text-white", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" },
                        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 3, d: "M5 13l4 4L19 7" }))),
                React.createElement("div", { className: "text-center" },
                    React.createElement("h2", { className: "text-2xl font-bold text-[#1F2751] mb-2" }, "Payment Submitted!"),
                    React.createElement("p", { className: "text-gray-600 mb-1" },
                        "Policy ",
                        stepInfo.current - 1,
                        " of ",
                        stepInfo.total - 1,
                        " completed"),
                    React.createElement("p", { className: "text-sm text-gray-500" },
                        stepInfo.total - stepInfo.current,
                        ' ',
                        stepInfo.total - stepInfo.current === 1 ? 'policy' : 'policies',
                        ' ',
                        "remaining")),
                React.createElement("div", { className: "w-full bg-gray-200 rounded-full h-2 mt-2" },
                    React.createElement("div", { className: "h-2 rounded-full transition-all duration-500", style: {
                            width: "".concat(((stepInfo.current - 1) / (stepInfo.total - 1)) * 100, "%"),
                            backgroundColor: primaryColor
                        } })),
                React.createElement("button", { onClick: handleContinue, className: "w-full py-3 px-6 rounded-xl text-white font-semibold text-lg transition-all hover:opacity-90", style: { backgroundColor: primaryColor } }, "Continue to Next Policy"))));
    }
    var isNextDisabled = isSubmitting || isPurchaseLoading;
    return (React.createElement("form", { className: modalOpen
            ? 'w-full h-[92vh] absolute top-1 left-0 flex flex-col items-center justify-start overflow-hidden sm:w-full sm:h-[95%]'
            : 'w-[80%]', onSubmit: function (e) { return e.preventDefault(); }, id: "cc-form" },
        !isPurchaseLoading && (React.createElement("div", { className: "w-full" },
            React.createElement(PolicyStepsHeader, { pageName: isMultipleFlow
                    ? "Payment ".concat(stepInfo.current, " of ").concat(stepInfo.total)
                    : 'Complete Payment', nextButtonText: rawComplianceText
                    ? 'Make Payment'
                    : isMultipleFlow && !isLastPolicy
                        ? 'Submit Payment'
                        : 'Purchase', backButtonText: "Cancel", handleClose: function () {
                    setSelectedPlan(null);
                    setPolicyPaymentPayloads([]);
                    setSelectedPolicyPayload(null);
                }, shouldConfirm: true, isNextDisabled: isNextDisabled }),
            React.createElement("div", { className: "flex flex-col w-full py-4 px-6" },
                rawComplianceText && (React.createElement("div", { className: "sectionBanner" },
                    React.createElement("div", { className: "w-full bg-red-50 border border-red-300 rounded-md px-4 py-3 shadow-sm" },
                        React.createElement("div", { className: "text-red-700 text-sm leading-snug text-center" }, rawComplianceText)))),
                React.createElement("h1", { className: "capitalize text-2xl text-[#1F2751] font-bold mt-3 text-center" }, "Payment Details"),
                isMultipleFlow && (React.createElement("p", { className: "text-center text-gray-600 mt-2 mb-4" },
                    "Completing payment for policy ",
                    stepInfo.current,
                    " of",
                    ' ',
                    stepInfo.total)),
                React.createElement("div", { className: "w-full rounded-2xl grid grid-cols-2 border-2 text-[#1F2751] mt-6 sm:flex sm:items-stretch sm:justify-between", style: {
                        backgroundColor: theme == 'night' ? shade(pColor, -0.7) : shade(pColor, 0.9),
                        borderColor: theme == 'night' ? shade(pColor, -0.6) : shade(pColor, 0.8)
                    } },
                    React.createElement("div", { className: "w-full flex items-center gap-x-6 pl-7 py-3" },
                        React.createElement(MoneyMinusIcon, null),
                        React.createElement("div", { className: "flex flex-col items-start text-[16px] sm:text-lg" },
                            React.createElement("div", { className: "flex items-baseline gap-x-1.5" },
                                React.createElement("span", { className: "font-bold" },
                                    "$",
                                    baseDownpayment.toFixed(2)),
                                hasCcFee && (React.createElement("span", { className: "text-xs font-normal opacity-80" },
                                    "(+$",
                                    downpaymentFee.toFixed(2),
                                    " fee)"))),
                            React.createElement("span", { className: "text-xs sm:text-sm" }, "Down Payment"))),
                    baseInstallment > 0 && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "w-full flex items-center gap-x-6 pl-7 py-3" },
                            React.createElement("div", { className: "w-[2px] h-full", style: {
                                    backgroundColor: theme == 'night'
                                        ? shade(pColor, -0.6)
                                        : shade(pColor, 0.8)
                                } }),
                            React.createElement(MoneyTagIcon, null),
                            React.createElement("div", { className: "flex flex-col items-start text-[16px] sm:text-lg" },
                                React.createElement("div", { className: "flex items-baseline gap-x-1.5" },
                                    React.createElement("span", { className: "font-bold" },
                                        "$",
                                        baseInstallment.toFixed(2)),
                                    hasCcFee && (React.createElement("span", { className: "text-xs font-normal opacity-80" },
                                        "(+$",
                                        installmentFee.toFixed(2),
                                        " fee)"))),
                                React.createElement("span", { className: "text-xs sm:text-sm" }, "Installment Payment"))),
                        React.createElement("div", { className: "w-full flex items-center gap-x-6 pl-7 py-3" },
                            React.createElement("div", { className: "w-[2px] h-full", style: {
                                    backgroundColor: theme == 'night'
                                        ? shade(pColor, -0.6)
                                        : shade(pColor, 0.8)
                                } }),
                            React.createElement(MoneyTagIcon, null),
                            React.createElement("div", { className: "flex flex-col items-start text-[16px] sm:text-lg" },
                                React.createElement("span", { className: "font-bold" }, installmentCount),
                                React.createElement("span", { className: "text-xs sm:text-sm" }, "Number of Installments"))))),
                    React.createElement("div", { className: "w-full flex items-center justify-center gap-x-6 py-3 bg-primary rounded-b-2xl text-white col-span-2 sm:rounded-2xl sm:justify-start sm:pl-7" },
                        React.createElement(MoneyWalletIcon, null),
                        React.createElement("div", { className: "flex flex-col items-start text-[16px] sm:text-lg" },
                            React.createElement("span", { className: "font-bold" },
                                "$",
                                totalPayableAmount.toFixed(2)),
                            React.createElement("span", { className: "text-xs sm:text-sm" },
                                "Total Payable Amount",
                                ' ',
                                hasCcFee && "(incl. ".concat(ccFeePercentStr, "% CC fee)")))))))),
        React.createElement("div", { className: "w-full flex flex-col items-start justify-start px-6 pt-8 overflow-y-auto" },
            React.createElement("div", { className: "flex flex-col gap-y-6 w-full" },
                React.createElement("div", { className: "grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2 briza-collect-form" },
                    React.createElement("div", { className: "briza-field-container w-full flex flex-col items-start gap-y-2" },
                        React.createElement("span", { className: "text-xl text-[#252846] font-medium w-full text-left" }, "Card Number:"),
                        React.createElement("span", { id: "card-number", className: "w-full h-[60px] briza-field" }),
                        React.createElement(ErrorMessage, { error: error, fieldPath: "payment.number" })),
                    React.createElement("div", { className: "briza-field-container w-full flex flex-col items-start gap-y-2" },
                        React.createElement("span", { className: "text-xl text-[#252846] font-medium w-full text-left" }, "Expiration Date:"),
                        React.createElement("span", { id: "card-expiration-date", className: "w-full h-[60px] briza-field" }),
                        React.createElement(ErrorMessage, { error: error, fieldPath: "payment" })),
                    React.createElement("div", { className: "briza-field-container w-full flex flex-col items-start gap-y-2" },
                        React.createElement("span", { className: "text-xl text-[#252846] font-medium w-full text-left" }, "Security Code:"),
                        React.createElement("span", { id: "card-security-code", className: "w-full h-[60px] briza-field" }),
                        React.createElement(ErrorMessage, { error: error, fieldPath: "payment.cvc" })),
                    React.createElement("div", { className: "briza-field-container w-full flex flex-col items-start gap-y-2" },
                        React.createElement("span", { className: "text-xl text-[#252846] font-medium w-full text-left" }, "Name on Card:"),
                        React.createElement("span", { id: "card-name", className: "w-full h-[60px] briza-field" }),
                        React.createElement(ErrorMessage, { error: error, fieldPath: "payment.name" })),
                    React.createElement("div", { className: "briza-field-container w-full flex flex-col items-start gap-y-2" },
                        React.createElement("span", { className: "text-xl text-[#252846] font-medium w-full text-left" }, "Email:"),
                        React.createElement("span", { id: "email", className: "w-full h-[60px] briza-field" }),
                        React.createElement(ErrorMessage, { error: error, fieldPath: "payment.email" })),
                    React.createElement("div", { className: "briza-field-container w-full flex flex-col items-start gap-y-2" },
                        React.createElement("span", { className: "text-xl text-[#252846] font-medium w-full text-left" }, "Address:"),
                        React.createElement("span", { id: "address", className: "w-full h-[60px] briza-field" }),
                        React.createElement(ErrorMessage, { error: error, fieldPath: "payment.address.street" })),
                    React.createElement("div", { className: "briza-field-container w-full flex flex-col items-start gap-y-2" },
                        React.createElement("span", { className: "text-xl text-[#252846] font-medium w-full text-left" }, "City:"),
                        React.createElement("span", { id: "city", className: "w-full h-[60px] briza-field" }),
                        React.createElement(ErrorMessage, { error: error, fieldPath: "payment.address.city" })),
                    React.createElement("div", { className: "briza-field-container w-full flex flex-col items-start gap-y-2" },
                        React.createElement("span", { className: "text-xl text-[#252846] font-medium w-full text-left" }, "State/Region:"),
                        React.createElement("span", { id: "region", className: "w-full h-[60px] briza-field" }),
                        React.createElement(ErrorMessage, { error: error, fieldPath: "payment.address.region" })),
                    React.createElement("div", { className: "briza-field-container w-full flex flex-col items-start gap-y-2" },
                        React.createElement("span", { className: "text-xl text-[#252846] font-medium w-full text-left" }, "ZIP Code:"),
                        React.createElement("span", { id: "zip-code", className: "w-full h-[60px] briza-field" }),
                        React.createElement(ErrorMessage, { error: error, fieldPath: "payment.address.postalCode" })),
                    React.createElement("div", { className: "briza-field-container w-full flex flex-col items-start gap-y-2" },
                        React.createElement("span", { className: "text-xl text-[#252846] font-medium w-full text-left" }, "Country:"),
                        React.createElement("span", { id: "country", className: "w-full h-[60px] briza-field" }),
                        React.createElement(ErrorMessage, { error: error, fieldPath: "payment.address.country" })))))));
};
export default BrizaPaymentForm;
